import request from '@/api/axios'

export const createFile = () =>
  request({
    url: '/files',
    method: 'post'
  })
